type Args = {
  volumeEmbedHost: string;
  uuid: string;
  autoplay: boolean | null;
  playerType: string;
};

export default function constructEmbedUrl({
  volumeEmbedHost,
  uuid,
  autoplay = false,
  playerType,
}: Args) {
  return `${volumeEmbedHost}/embed/${uuid}?autoplay=${
    autoplay ? "true" : "false"
  }&loop=true&placement=article&player_type=${playerType.toLowerCase()}&tracking=article:middle`;
}
